export default __webpack_public_path__ + "static/customer_sprague_thumb_3-7134b160ef8b53131c6ecd9ca5c71436.png";